<template>
  <div>
    <year-filter-bar @change="onYearChange" ref="yearFilterBar" />

    <div class="canvas-box">
      <canvas id="myChart" class="myChart"></canvas>
    </div>

    <div class="list-box" v-if="result.monthitems">
      <div class="list-box-col">
        <p class="list-box-col__title">月份</p>
        <p
          class="list-box-col__content"
          v-for="item in result.monthitems"
          :key="item.text"
        >
          {{ item.text }}
        </p>
        <!-- <p class="list-box-col__content">本年累计</p> -->
      </div>
      <div
        class="list-box-col list-box-active"
        @click="initChart(deal2(result.details[0]))"
      >
        <p class="list-box-col__title">来料总批</p>
        <p
          class="list-box-col__content"
          style="color: #2eadf5"
          v-for="item in result.monthitems"
          :key="item.text"
        >
          {{ item.count }}
        </p>
        <!-- <p class="list-box-col__content">{{ result.details[0].amount }}</p> -->
      </div>
      <div
        class="list-box-col list-box-active"
        @click="initChart(deal2(result.details[1]))"
      >
        <p class="list-box-col__title">合格批</p>
        <p
          class="list-box-col__content"
          style="color: #e44959"
          v-for="item in result.monthitems"
          :key="item.text"
        >
          {{ item.okcount }}
        </p>
        <!-- <p class="list-box-col__content">{{ result.details[1].amount }}</p> -->
      </div>
      <div
        class="list-box-col list-box-active"
        @click="initChart(deal2(result.details[2]))"
      >
        <p class="list-box-col__title">不合格批</p>
        <p
          class="list-box-col__content"
          style="color: #000"
          v-for="item in result.monthitems"
          :key="item.text"
        >
          {{ item.ngcount }}
        </p>
        <!-- <p class="list-box-col__content">{{ result.details[2].amount }}</p> -->
      </div>
      <div
        class="list-box-col list-box-active"
        @click="initChart(deal2(result.details[3]))"
      >
        <p class="list-box-col__title">批次合格率%</p>
        <p
          class="list-box-col__content"
          style="color: #16b603"
          v-for="item in result.monthitems"
          :key="item.text"
        >
          {{ item.okrate }}
        </p>
        <!-- <p class="list-box-col__content">{{ result.details[2].amount }}</p> -->
      </div>
    </div>
  </div>
</template>

<script>
import YearFilterBar from "@/components/YearFilterBar.vue";
// import F2 from '@antv/f2'
import F2 from "@antv/f2/lib/index";
import ScrollBar from "@antv/f2/lib/plugin/scroll-bar";
import "@antv/f2/lib/interaction/pan";

export default {
  components: {
    YearFilterBar,
  },
  data() {
    var year = new Date().getFullYear();

    return {
      year,
      result: {},
      chart: null,
    };
  },
  mounted() {
    this.searchPurcSaleMonth();
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
    if (this.chart) {
      this.chart.destroy();
    }
  },
  methods: {
    searchPurcSaleMonth() {
      let me = this;

      me.$ajax({
        url: "/api/qc/report/iqcAnalysis?year=" + me.year,
      }).then(function (res) {
        if (res.success) {
          me.result = res.data;
          me.initChart(me.deal(me.result.monthitems));
        }
      });
    },
    onResize() {
      var chart = this.chart;
      if (chart) {
        this.chart = chart.destroy();
        this.initChart(this.deal(this.result.monthitems));
      }
    },
    initChart(data) {
      var chart = this.chart;
      if (chart) {
        chart.changeData(data);
        return;
      }
      this.chart = chart = new F2.Chart({
        id: "myChart",
        width: window.innerWidth,
        height: Math.min(window.innerHeight * 0.6, 300),
        pixelRatio: window.devicePixelRatio,
        plugins: ScrollBar,
      });

      chart.source(data, {
        index: {
          type: "linear",
          tickInterval: 1,
          min: -1,
          max: window.innerWidth > window.innerHeight ? 12 : 6,
          formatter: (i) =>
            i > -1 && i < 12
              ? [
                  "01月",
                  "02月",
                  "03月",
                  "04月",
                  "05月",
                  "06月",
                  "07月",
                  "08月",
                  "09月",
                  "10月",
                  "11月",
                  "12月",
                ][i]
              : null,
        },
      });

      chart
        .interval()
        .position("index*value")
        .color("type", (val) => {
          if (val === "来料总批数") {
            return "#2eadf5";
          } else if (val === "合格批数") {
            return "#e44959";
          } else if (val === "不合格批数") {
            return "#000";
          } else if (val === "批次合格率%") {
            return "#16b603";
          }
        })
        .adjust({
          type: "dodge",
          marginRatio: 0.05, // 设置分组间柱子的间距
        });

      if (window.innerWidth < window.innerHeight) {
        // 定义进度条
        chart.scrollBar({
          mode: "x",
          xStyle: {
            backgroundColor: "#e8e8e8",
            fillerColor: "#808080",
            offsetY: -2,
          },
        });
      }
      chart.interaction("pan");
      chart.render();
    },
    deal(data) {
      const textArr = [
        "01月",
        "02月",
        "03月",
        "04月",
        "05月",
        "06月",
        "07月",
        "08月",
        "09月",
        "10月",
        "11月",
        "12月",
      ];

      let arr = [
        { index: -1, type: "来料总批数", value: 0 },
        { index: 12, type: "来料总批数", value: 0 },
      ];
      data.forEach((item, i) => {
        arr.push(
          {
            text: item.text,
            type: "来料总批数",
            index: i,
            value: item.count,
          },
          {
            text: item.text,
            type: "合格批数",
            index: i,
            value: item.okcount,
          },
          {
            text: item.text,
            type: "不合格批数",
            index: i,
            value: item.ngcount,
          },
          {
            text: item.text,
            type: "批次合格率%",
            index: i,
            value: item.okrate,
          }
        );
      });

      const l = arr.length / 4;
      if (l < 12) {
        for (let i = l; i < 12; i++) {
          arr.push(
            {
              text: textArr[i],
              type: "来料总批数",
              index: i,
              value: 0,
            },
            {
              text: textArr[i],
              type: "合格批数",
              index: i,
              value: 0,
            },
            {
              text: textArr[i],
              type: "不合格批数",
              index: i,
              value: 0,
            },
            {
              text: textArr[i],
              type: "合格率%",
              index: i,
              value: 0,
            }
          );
        }
      }
      return arr;
    },
    deal2(data) {
      if (!data) return;
      const textArr = [
        "01月",
        "02月",
        "03月",
        "04月",
        "05月",
        "06月",
        "07月",
        "08月",
        "09月",
        "10月",
        "11月",
        "12月",
      ];

      let arr = [
        { index: -1, type: data.text, value: 0 },
        { index: 12, type: data.text, value: 0 },
      ];
      for (let i = 0; i < 12; i++) {
        arr.push({
          index: i,
          text: textArr[i],
          type: data.text,
          value: data["amount" + (i + 1)] || 0,
        });
      }
      return arr;
    },
    onYearChange(year) {
      this.year = year;
      this.searchPurcSaleMonth();
    },
  },
};
</script>

<style scoped>
.canvas-box {
  /* width: 100%;
  height: 100%; */
  overflow-x: scroll;
  background: var(--weui-BG);
}

.list-box {
  margin-top: 5px;
  background: var(--weui-BG);
  width: 100%;
  display: flex;
  justify-content: space-around;
}
.list-box-active:active {
  background: #e0e0e0;
}
.list-box-col {
  text-align: center;
}
.list-box-col p {
  line-height: 40px;
}
.list-box-col__title {
  font-weight: bold;
}
.list-box-col__content {
  font-size: small;
  color: var(--weui-FG-0);
}
@media screen and (min-width: 500px) {
  .filter-bar {
    padding: 6px 0 2px 0;
  }
  .list-scroll-wrap {
    width: 100%;
  }
  .list-box-col p {
    line-height: 25px;
  }
}
</style>